import axios from 'axios';
import APIClient from './apiClient';
import { api } from '../config';
import store from '../store';
// eslint-disable-next-line no-unused-vars
import { logoutUserSuccess } from '../slices/auth/login/reducer';

// Instance APIClient dengan baseURL
export const apiClient = new APIClient(api.API_URL);

// Axios Global Config
axios.defaults.headers.post['Content-Type'] = 'application/json';

// Interceptor Request
axios.interceptors.request.use(
  config => {
    const token = store.getState()?.Login?.user?.token;
    if (token && typeof token === 'string' && token.trim().length > 0) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // Try fallback token sources
      const sessionUser = sessionStorage.getItem('authUser');
      if (sessionUser) {
        try {
          const parsedUser = JSON.parse(sessionUser);
          const sessionToken = parsedUser?.token;
          if (
            sessionToken &&
            typeof sessionToken === 'string' &&
            sessionToken.trim().length > 0
          ) {
            config.headers.Authorization = `Bearer ${sessionToken}`;
          }
        } catch (error) {
          // Failed to parse session user
        }
      }
    }
    return config;
  },
  error => Promise.reject(error)
);

// Interceptor Response
// axios.interceptors.response.use(
//   (response) => response.data ?? response,
//   (error) => {
//     const message =
//       error.response?.data?.message || error.message || "Terjadi kesalahan";
//     return Promise.reject(message);
//   }
// );

// // Helper functions

axios.interceptors.response.use(
  response => response?.data ?? response,
  error => {
    let message = 'An error occurred in the system.';

    if (error.response) {
      const data = error.response.data;

      // AUTO_LOGOUT_DISABLED_START — disabled per issue #24 (multi-login support), 2026-07-17
      // if (error.response.status === 401) {
      //   sessionStorage.clear();
      //   store.dispatch(logoutUserSuccess());
      //   window.location.href = '/login';
      //   return Promise.reject(new Error('Session expired'));
      // }
      // AUTO_LOGOUT_DISABLED_END

      if (typeof data === 'string') {
        message = data;
      } else if (data?.message) {
        message = data.message;
      } else if (data?.error) {
        message = data.error;
      } else {
        message = `Error ${error.response.status}: ${error.response.statusText}`;
      }
    } else if (error.request) {
      message = 'No Response from Server.';
    } else {
      message = error.message;
    }

    return Promise.reject(new Error(message));
  }
);

export const getLoggedinUser = () => store.getState()?.Login?.user || null;
